import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CropFreeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"crop_free"}/>
}
